import Link from 'next/link';
import { FC } from 'react';
import { getRoute } from '#utils';
import {
  CategoryTeaserFragment,
  ContentType,
  StudioTeaserFragment,
} from '#types/generated/graphql-types';
import useTranslation from 'next-translate/useTranslation';
import { ITeaserRenderer } from '#components/lists/horizontal-scroll-list/HorizontalScrollList';

interface ISquareTeaserRenderer extends ITeaserRenderer {
  teaserDataRaw: CategoryTeaserFragment | StudioTeaserFragment;
}

const SquareTeaser: FC<ISquareTeaserRenderer> = ({ teaserDataRaw }) => {
  const { t } = useTranslation();
  const logoImage = teaserDataRaw?.logoImageFormats?.oneByOne?.medium;

  return (
    <Link
      href={getRoute(
        {
          slug: teaserDataRaw.slug,
          contentType:
            teaserDataRaw.__typename === 'Studio'
              ? ContentType.Studio
              : ContentType.Category,
        },
        t
      )}
    >
      <div
        className={`tw-relative ${
          logoImage && 'tw-p-1'
        } tw-cursor-pointer tw-inline-block tw-bg-black tw-rounded-2xl tw-overflow-hidden tw-aspect-[1/1] tw-w-full tw-group`}
      >
        <h4 className="tw-sr-only">{teaserDataRaw.title}</h4>
        <img
          className="group-hover:tw-scale-105 tw-transition tw-transform tw-duration-200 tw-ease-in-out"
          src={logoImage || '/static/placeholder/1-1.jpg'}
          alt={teaserDataRaw.title}
        />
      </div>
    </Link>
  );
};

export default SquareTeaser;
